<template>
  <div class="col-10 col-lg-3">

    <div class="sidebar sidebar-content mb-4">
      <h2 class="price__range display-3">Actief scherm</h2>
    </div>

    <div class="sidebar me-auto mb-4 fade-in" v-for="item in items">
      <div v-if="item.active">
        <img :src="`/storage/${item.image}`" class="card-img-top" :alt="item.title">
        <Card :title="item.title" :description="item.description"></Card>
      </div>
    </div>

    <div class="sidebar me-auto mb-4 fade-in" v-if="status == 'start'">
      <img src="/img/qr-code.png" class="card-img-top">
      <Card title="Welkom bij de Veense Veiling" description="Scan de QR code of ga naar: klok.veenseveiling.nl"></Card>
    </div>

    <div class="sidebar me-auto mb-4 fade-in" v-if="status == 'end'">
      <img src="/img/logo.svg" class="card-img-top">
      <Card title="Tot ziens in de Veense Veiling"
            description="Leuk dat je er was! Vergeet niet je veiling items mee te nemen / af te rekenen."></Card>
    </div>
  </div>

  <div class="col-10 col-lg-6">
    <div class="controls ms-auto mb-4" v-if="status != 'running'">
      <div class="card pe-3">
        <div class="card-body">
          <h5 class="card-title mb-4">Veiling</h5>
          <div class="row">
            <div class="col-12">
              <button class="btn btn-primary me-2 mb-2" @click="auctionStart">Start Veiling</button>
              <button v-if="status == 'end'" class="btn btn-primary me-2 mb-2" @click="startScreen">Start Scherm</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(item, index) in items">
      <div v-if="item.active == 1">
        <div class="controls mb-4 ms-auto" v-if="status == 'running'">
          <div class="card pe-3 mb-4">
            <div class="card-body">
              <h5 class="card-title mb-4">Items</h5>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary me-2 mb-2" v-if="items[index - 1]"
                          @click="setActiveItem(items[index].id, items[index - 1].id)">Vorige Item
                  </button>
                  <button class="btn btn-primary me-2 mb-2" v-if="items[index + 1]"
                          @click="setActiveItem(items[index].id, items[index + 1].id)">Volgende Item
                  </button>
                  <button class="btn btn-primary me-2 mb-2" v-if="!items[index + 1]" @click="auctionEnd">Einde Veiling
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="controls mb-4 ms-auto" v-if="item.purchased_by.length == 0">
          <div class="card pe-3">
            <div class="card-body">
              <h5 class="card-title mb-4">Klok</h5>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary me-2 mb-2" id="startButton" @click="clock(items[index].id,'start')">Start de Klok
                  </button>
                  <button class="btn btn-primary me-2 mb-2" id="pauseButton" @click="clock(items[index].id,'stop')">Pauzeer de Klok
                  </button>
                  <button class="btn btn-primary me-2 mb-2" id="resetButton" @click="clock(items[index].id,'restart')">Reset de Klok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="controls mb-4 ms-auto">
          <div class="card pe-3">
            <div class="card-body">
              <h5 class="card-title mb-4">Veiling</h5>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary me-2 mb-2" id="startButton" @click="auctionEnd">Stop veiling
                  </button>
                  <button class="btn btn-primary me-2 mb-2" id="pauseButton" @click="clock(null, 'scoreBoard')">Scoreboard
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-10 col-lg-3 pt-0">
    <div class="sidebar me-auto mb-4 fade-in">
      <div v-for="item in items">
        <div v-if="item.active && item.purchased_by[0]" class="card pe-3">
          <div class="card-body">
            <h2 class="display-3 mb-0"> Winnaar
              <div class="text-uppercase mb-5">{{ item.purchased_by[0].name }}</div>
            </h2>
            <p class="option__name">Geboden</p>
            <p class="price mb-5"> &euro; {{ formatNumber(item.purchased_by[0].pivot.price) }} </p>
            <p class="option__name">Totaal kosten</p>
            <p class="price">&euro; {{ formatNumber(item.purchased_by[0].pivot.price * item.units_per_pack) }} </p>
            <button class="btn btn-primary me-2" @click="removePurchase(item.id)">Verwijder Winnaar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "../general/Card";

export default {
  components: {
    Card,
  },
  data() {
    return {
      item: {},
      items: {},
      status: 'start',
    };
  },
  mounted() {
    this.getAuctionStatus();
    this.getItems();
    this.listen();
  },

  methods: {
    setActiveItem(old_id, new_id) {
      let uri = '/api/auction/' + this.getActiveItem().auction_id + '/item/' + new_id + '/active'
      this.axiosRequest(uri, 'POST', function () {
      })

      const event = Echo.private('auction-channel-'+ this.getActiveItem().auction_id)
        .whisper('restart', {});

      this.items.map(function (item) {
        if (item.id === old_id) {
          item.active = 0;
        } else if (item.id === new_id) {
          item.active = 1;
        }
      })

    },
    auctionStart() {
      this.finished = false;
      let uri = '/api/auction/' + this.getAuctionIdFromUrl() + '/start'
      this.axiosRequest(uri, 'POST', this.setStatus('running', true));
      if(this.items[0].active !== 1){
        this.items[0].active = 1
      }


      const event = Echo.private('auction-channel-' + this.getAuctionIdFromUrl())
        .whisper('start', {});
    },
    auctionEnd() {
      let uri = '/api/auction/' + this.getActiveItem().auction_id + '/end'
      this.axiosRequest(uri, 'POST', this.setStatus('end'))
      this.getItems();
    },
    clock(id, status) {
      if(status == 'start'){
        this.toggleActiveButton('startButton', true);
        this.toggleActiveButton('pauseButton', false);
      }
      if(status == 'stop'){
        this.toggleActiveButton('startButton', false);
        this.toggleActiveButton('pauseButton', true);
      }
      if(status == 'reset'){
        this.toggleActiveButton('startButton', false);
        this.toggleActiveButton('pauseButton', false);
      }

      const event = Echo.private('auction-channel-'+ this.getActiveItem().auction_id)
        .whisper(status, {});

    },
    toggleActiveButton(id, state){
      let button = document.getElementById(id)
      state ? button.classList.add('active') : button.classList.remove('active');
    },
    removePurchase(id) {
      let uri = '/api/auction/' + this.getActiveItem().auction_id + '/item/' + id + '/purchase';
      this.axiosRequest(uri, 'DELETE', this.clearLocalPurchase(id));
      this.clock(id, 'delete');
      this.clock(id, 'restart');
    },
    getAuctionStatus() {
      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: 'GET',
        url: '/api/auction/' + this.getAuctionIdFromUrl() + '/status',
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if (
                response.data.status &&
                response.data.status == 'success' &&
                response.data.data) {
              this.status = response.data.data;
            }
          });
    },
    getItems() {
      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: 'GET',
        url: '/api/auction/' + this.getAuctionIdFromUrl() + '/item',
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if (
                response.data.status &&
                response.data.status == 'success' &&
                response.data.result) {
              this.items = response.data.result;
            }
          });
    },
    formatNumber(price) {
      if (price) {
        return price.toFixed(2);
      }
      return;

    },
    clearLocalPurchase(id) {
      this.items.map(function (item) {
        if (item.id === id) {
          item.purchased_by = []
        }
      })
      this.finished = false;
    },
    setStatus(status, start = false) {
      if(start == false){
        this.getItems()
      }
      this.status = status;
    },
    axiosRequest(uri, method, callback) {
      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: method,
        url: uri,
        data: {'X-CSRF-TOKEN': csrfToken},
      })
          .then(response => {
            if (
                response.data.status &&
                response.data.status == 'success') {
              callback;
            }
          });
    },
    listen() {
      const event = Echo.private('auction-channel-' + this.getAuctionIdFromUrl())
        .listenForWhisper('purchase_confirm', (e) => {
          this.items.map(function (item) {
            if (item.id === e.item_id) {
              item.purchased_by = [e]
            }
          })
        })
        .listenForWhisper('restart', (e) => {
          this.toggleActiveButton('startButton', false);
          this.toggleActiveButton('pauseButton', false);
        })
    },
    getActiveItem() {
        return this.items.filter(item => {
            return item.active === 1;
        })[0];
    },
    startScreen(){
      const event = Echo.private('auction-channel-' + this.getAuctionIdFromUrl())
        .whisper('startScreen')

      window.location.reload();
    },
    getAuctionIdFromUrl(){
      return parseInt(window.location.pathname.split('/')[2]);
    }
  }
}
</script>
